import { mutations } from '@/store/common/types';
import type { App } from 'vue';
import { mapMutations } from 'vuex';
// import { CrispType } from "@/types/index";

declare global {
  interface Window {
    Intercom: any;
    mainBody: any;
  }
}

export default (app: App) => {
  app.mixin({
    data() {
      return {};
    },
    computed: {},
    methods: {
      ...mapMutations('common', {
        openPopup: mutations.OPEN_POPUP,
        toggleGlobalLoading: mutations.TOGGLE_GLOADING,
      }),
    },
  });
  app.config.globalProperties.$center = {
    visualFrame: null,
    navbar: null,
    editor: null,
    notifications: null,
    sidsebar: null,
    gframe: null,
    guid: null,
    gloader: null,
    library: null,
    gtooltip: null,
  };
  app.config.globalProperties.$chatbox = {
    /**
     * show
     */
    show: () => {
      if (window.Intercom) window.Intercom('show');
    },
    /**
     * hide
     */
    hide: () => {
      if (window.Intercom) window.Intercom('hide');
    },
  };
  app.config.globalProperties.$body = () => {
    return window.mainBody;
  };
};

/**
 * Create a backup of body
 * @returns {Object} object
 */
function __createBackup() {
  return {
    body: {
      position: '',
    },
  };
}

// const IntercomGemController = (function() {
//   const __backup = __createBackup();
//   let __closerId = "__intercomCloser";
//   const clickToClose = () => {
//     window.Intercom && window.Intercom("hide");
//   };

//   function onShow() {
//     __backup.body.position = document.body.style.position;
//       document.body.style.position = "relative";
//       const $intercom = document.getElementById("intercom-frame");
//       const $closer = __createCloser(__closerId)
//       $intercom.parentNode.insertBefore($closer, $intercom);
//       setTimeout(() => {
//         window.addEventListener("click", clickToClose);
//       }, 0)
//   }

//   function onHide() {
//     document.body.style.position = __backup.body.position;
//     const $closer = document.getElementById(__closerId);
//     if ($closer) {
//       $closer.parentNode.removeChild($closer);
//     }
//     window.removeEventListener("click", clickToClose);
//   }
//   return {
//     onShow,
//     onHide,
//   }
// })();

const interval = setInterval(() => {
  // Initiate closer for intercom
  if (window.Intercom) {
    clearInterval(interval);
    const __backup = __createBackup();
    let __closerId = '__closer';

    /**
     * clickToClose
     */
    const clickToClose = () => {
      window.Intercom && window.Intercom('hide');
    };
    window.Intercom('onShow', () => {
      __closerId = `__${Date.now()}`;
      __backup.body.position = document.body.style.position;
      document.body.style.position = 'relative';
      const $closer = document.createElement('div');
      $closer.id = __closerId;
      const $intercom = document.getElementById('intercom-frame');
      $closer.style.position = 'absolute';
      $closer.style.top = '0';
      $closer.style.right = '0';
      $closer.style.bottom = '0';
      $closer.style.left = '0';
      $closer.style.height = 'calc(100vh - 60px)';
      $closer.style.zIndex = '2147482900';
      (($intercom as any).parentNode as any).insertBefore($closer, $intercom);
      setTimeout(() => {
        window.addEventListener('click', clickToClose);
      }, 0);
    });
    window.Intercom('onHide', () => {
      document.body.style.position = __backup.body.position;
      const $closer = document.getElementById(__closerId);
      if ($closer) {
        ($closer.parentNode as any).removeChild($closer);
      }
      window.removeEventListener('click', clickToClose);
    });
  }
  // if (window.Intercom) {
  //   clearInterval(interval);
  //   window.Intercom("onShow", IntercomGemController.onShow);
  //   window.Intercom("onHide", IntercomGemController.onHide);
  // }
}, 50);
